import axios from "axios";
import { decryptData, encryptData } from "../utils/encrypt";
const isDevelopment = process.env.REACT_APP_IS_DEVELOPMENT;
const services = (() => {
  let token;
  const getToken = () => {
    const encryptedToken = sessionStorage.getItem("token");
    token = decryptData(encryptedToken);
    return token;
  };
  const createHeaders = () => ({
    Accept: "*/*",
    "Accept-Language": "en-US,en;q=0.9",
    calling_entity: "ui",
    "Content-Type": "application/json; charset=utf-8",
    Authorization: getToken(),
  });
  const handleError = (error, key) => {
    console.error('Error in services', error);
    if (error?.response?.status === 401) {
      if (!window.location.href.includes('atlassian.net') && key !== "inspectra") {
        sessionStorage.clear()
        window.location.pathname = "/sign-in"
      }
      return error.response.data.errorMessage;
    }
    throw error;
  };

  return {
    createParameter(method, path, payload) {
      const headers = createHeaders();
      const isLocal = sessionStorage.getItem("platform") === "local";
      !isLocal && delete headers.Authorization
      const baseUrl = `${process.env.REACT_APP_BASEURL}${path}`;
      let encryptedPayload = payload;
      if (isDevelopment === "false") {
        encryptedPayload = { data: encryptData(payload) };
      }
      return {
        method,
        // ...(isLocal ? { url: baseUrl } : { path }),
        url: baseUrl,
        headers,
        ...((method === 'POST' || method === 'DELETE') && isLocal ? { data: encryptedPayload } : {}),
        ...((method === 'POST' || method === 'DELETE') && !isLocal ? { body: encryptedPayload } : {}),
        ...(method === 'GET' ? { params: payload } : {}),
      };
    },

    async getInvokeRemote(method, path, payload) {
      const parameter = this.createParameter(method, path, payload);
      try {
          const response = await axios(parameter);
          if (isDevelopment === "false") {
            const decrypt = decryptData(response.data?.data)
            response.data.data = decrypt
            response.body = response.data
            delete response.data
            return response
          } else {
            return { ...response, body: response.data };
          }
      } catch (error) {
        return handleError(error);
      }
    },

    async login(path, payload, type,responseType) {    
      const url = `${process.env.REACT_APP_BASEURL}${path}`;
    
      // For GET requests, append payload as query parameters
      const finalUrl = type === "GET" && payload ? `${url}?${new URLSearchParams(payload).toString()}` : url;
    
      const config = {
        url: finalUrl, // Use the final URL with query parameters for GET
        method: type === "GET" ? "GET" : "POST",
        headers: createHeaders(),
      };
    
      // Only add data for POST requests (GET should not have a body)
      if (type !== "GET") {
        config.data = payload;
      }
      if(responseType === 'image'){
        config.responseType = 'blob'
      }
    
      try {
        const response = await axios(config);
        return { ...response, body: response.data };
      } catch (error) {
        console.error("Error in axios request", error);
        throw error;
      }
    },

    async callInspectra(method, path, payload, domainKey) {
      try{
        const url = domainKey && isDevelopment === "false" ? domainKey : process.env.REACT_APP_BASEURL;
        const response = await axios( {method,
          url: `${url}${path}` ,
          headers: {
            'AuthToken': decryptData(sessionStorage.getItem("token")),
            'UserCode': decryptData(sessionStorage.getItem("user_code"))
          },
          ...(method === 'POST' ? { data: payload } : {}),
          ...(method === 'GET' ? { params: payload } : {}),
        });
        return response?.data;
      } catch (error) {
        return handleError(error, "inspectra");
      }
    }
    
  };

})();
export default services;